export const ROLE_PERMISSIONS = Object.freeze({
  SUPER_ADMIN: ["devices:view", "devices:edit", "dashboard:view", "users:view", "users:edit", "ip-access:view", "ip-access:edit", "categories:view", "categories:edit", "accounts:view", "accounts:edit", "accounts:delete", "transactions:view", "transactions:edit", "transactions:delete", "reconciliations:view", "reconciliations:edit", "audit:view"],
  ADMIN: ["devices:view", "devices:edit", "dashboard:view", "users:view", "users:edit", "ip-access:view", "ip-access:edit", "categories:view", "categories:edit", "accounts:view", "accounts:edit", "accounts:delete", "transactions:view", "transactions:edit", "transactions:delete", "reconciliations:view", "reconciliations:edit", "audit:view"],
  OPERATOR: ["dashboard:view", "accounts:view", "transactions:view", "transactions:edit", "transactions:delete", "reconciliations:view", "reconciliations:edit"],
  AUDITOR: ["dashboard:view", "accounts:view", "transactions:view", "reconciliations:view"],
});

const LEGACY_PERMISSION_ALIASES = Object.freeze({
  "users:manage": "users:edit",
  "ip-access:manage": "ip-access:edit",
  "categories:manage": "categories:edit",
  "audit:read": "audit:view",
  "accounts:read": "accounts:view",
  "accounts:manage": "accounts:edit",
  "transactions:read": "transactions:view",
  "finance:write": "transactions:edit",
  "reports:read": "reconciliations:view",
});

const ASSIGNABLE_ROLES = Object.freeze({
  SUPER_ADMIN: ["ADMIN", "OPERATOR", "AUDITOR"],
  ADMIN: ["OPERATOR", "AUDITOR"],
  OPERATOR: [],
  AUDITOR: [],
});

export function hasPermission(subject, permission) {
  if (permission === "receipts:manage") {
    return (typeof subject === "string" ? subject : subject?.role) === "OPERATOR"
      && hasPermission(subject, "transactions:edit");
  }
  const normalized = LEGACY_PERMISSION_ALIASES[permission] || permission;
  if (subject && typeof subject === "object" && Array.isArray(subject.permissions)) {
    return subject.permissions.includes(normalized);
  }
  const role = typeof subject === "string" ? subject : subject?.role;
  return (ROLE_PERMISSIONS[role] || []).includes(normalized);
}

export function firstAccessiblePath(user) {
  const candidates = [
    ["dashboard:view", "/dashboard"],
    ["users:view", "/system/users"],
    ["ip-access:view", "/system/ip-access"],
    ["accounts:view", "/bank-accounts"],
    ["devices:view", "/devices"],
    ["transactions:view", "/transactions"],
    ["reconciliations:view", "/reconciliations"],
    ["audit:view", "/system/audit-logs"],
  ];
  return candidates.find(([permission]) => hasPermission(user, permission))?.[1] || "/account/me";
}

export function assignableRoles(role, canManageUsers = false) {
  if (canManageUsers && !ASSIGNABLE_ROLES[role]?.length) return ["OPERATOR", "AUDITOR"];
  return [...(ASSIGNABLE_ROLES[role] || [])];
}
